var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusInCircle(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.6,
    r: 11.5,
    stroke: "#1C1C1C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.6a.648.648 0 00-.649.649v4.702H7.15a.648.648 0 100 1.298h4.702v4.702a.648.648 0 101.298 0V13.25h4.702a.648.648 0 100-1.298H13.15V7.25A.648.648 0 0012.5 6.6z",
    fill: "#1C1C1C"
  })));
}
export default SvgPlusInCircle;